import { useEffect, useState } from 'preact/hooks';
import NavigationUtils from '../../utils/navigation.utils';
import CreditOnboardingEgyptLuckyV1 from '../../components/CreditOnboarding/CreditOnboardingEgyptLuckyV1/CreditOnboardingEgyptLuckyV1';
import CreditService from '../../services/credit.service';
import { renderIf } from '../../utils/render.utils';
import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import { CompletePageSuccessType } from '../CompletePage/CompletePageSuccessConfig';
import { CompleteStyles } from '../CompletePage/CompletePage';
import Base64 from '../../utils/base64.utils';
import { CompletePageFailureType } from '../CompletePage/CompletePageFailureConfig';
import OnboardingExitModal, {
  ModalType,
} from '../../components/Onboarding/OnboardingExitModal/OnboardingExitModal';

export default function CreditOnboardingPage({
  popup,
  organization,
  productId,
}) {
  const [loading, setLoading] = useState(true);
  const [pageConfig, setPageConfig] = useState({});

  useEffect(() => {
    if (!organization) {
      return NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
    }

    CreditService.getCreditConfig(organization)
      .then(({ data }) => {
        setPageConfig(data);
        setLoading(false);
      })
      .catch(err => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  const handleFormSubmit = formData => {
    setLoading(true);
    const params = { organizationCode: organization };
    const encodedParams = Base64.encode(JSON.stringify(params));
    CreditService.saveCreditOnboardingForm(organization, productId, formData)
      .then(({}) => {
        setLoading(false);
        NavigationUtils.navigate(
          `${NavigationUtils.Routes.COMPLETE}/${CompleteStyles.SUCCESS}/${CompletePageSuccessType.CREDIT_ONBOARDING_SUCCESS}`,
          false,
          { params: encodedParams },
        );
      })
      .catch(err => {
        setLoading(false);
        NavigationUtils.navigate(
          `${NavigationUtils.Routes.COMPLETE}/${CompleteStyles.FAILURE}/${CompletePageFailureType.CREDIT_ONBOARDING_FAILURE}`,
          false,
          { params: encodedParams },
        );
      });
  };

  const showPopup = () => {
    NavigationUtils.navigate(NavigationUtils.Routes.CREDIT_ONBOARDING, false, {
      popup: true,
    });
  };

  return (
    <>
      {renderIf(loading, <LoadingScreen />)}
      {renderIf(
        !loading,
        <>
          <CreditOnboardingEgyptLuckyV1
            pageConfig={pageConfig}
            onCloseClick={showPopup}
            onBackClick={showPopup}
            onFormSubmit={handleFormSubmit}
            organization={organization}
          />
          <OnboardingExitModal
            type={ModalType.CREDIT_ONBOARDING}
            showing={!!popup}
            onCloseClick={() => {
              NavigationUtils.navigate(
                NavigationUtils.Routes.CREDIT_ONBOARDING,
                true,
              );
            }}
          />
        </>,
      )}
    </>
  );
}
